module.exports = __webpack_public_path__ + "static/img/expert1.176beea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/expert1.png
// module id = 4nwT
// module chunks = 1